// `lg` is the hero tier — landing-page and journey CTAs. Not for dense
// list/table chrome or toolbar rows.
export const CONTROL_HEIGHT = {
    sm: 28,
    md: 36,
    lg: 48,
};
// A badge (Pill size="xs"): 12px label-sm + 8px vertical padding, below the
// control ladder. A slot that holds a row of badges reserves this height.
export const BADGE_HEIGHT = 20;
//# sourceMappingURL=sizing.js.map